import { render, staticRenderFns } from "./BetgameEditChatBot.vue?vue&type=template&id=649e2548&scoped=true"
import script from "./BetgameEditChatBot.vue?vue&type=script&lang=js"
export * from "./BetgameEditChatBot.vue?vue&type=script&lang=js"
import style0 from "./BetgameEditChatBot.vue?vue&type=style&index=0&id=649e2548&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "649e2548",
  null
  
)

export default component.exports